export enum FriendlyErrorMessage {
  NetworkError = 'It looks like you are not connected to the internet. Please check your network connection and try again.',
  UnknownError = 'An unknown error occurred.',
  UnauthorizedError = 'You are not authorized to perform this action.',
  DefaultError = 'There was a problem handling your request. Please try again.',
  ForbiddenError = 'You do not have permission to access this resource.',
  OperationCanceled = 'The operation was canceled.',
}

/**
 * Interface representing the parameters for an error message.
 * Used to display error messages in the application.
 */
export interface ErrorMessageDetails {
  message: string;
  header?: string;
}
